import Text from '@shared/components/content/text';
import { CopyButton } from './copy-button';

interface SECRReportSectionProps {
  title: string;
  icon: React.ReactNode;
  onCopy: () => Promise<void> | void;
  children: React.ReactNode;
}

export function SECRReportSection({
  title,
  icon,
  onCopy,
  children,
}: SECRReportSectionProps) {
  return (
    <section className="space-y-4">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          {icon}
          <Text variant="h2" className="text-lg font-semibold">
            {title}
          </Text>
        </div>
        <CopyButton
          onCopy={onCopy}
          variant="ghost"
          size="sm"
          className="h-7 shrink-0 gap-1.5 text-xs text-muted-foreground"
        />
      </div>
      {children}
    </section>
  );
}
